import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @param {boolean} localizing -> th가 3rem으로 폭이 줄어야 한다.
 * @returns {로컬라이징 - 자동 입력 레이블 구역. 텍스트가 그레이}
 */
type Iprops = {
  children?: string | JSX.Element;
  style?: React.CSSProperties;
  className?: string;
};
const TextGrayBox: React.FC<Iprops> = ({ children, style }) => {
  return (
    <StyledText style={style}>
      <p>{children}</p>
    </StyledText>
  );
};

export default TextGrayBox;

const StyledText = styled.div`
  width: 100%;
  background-color: #f0f0f0;
  padding: 0.25rem 0.75rem;
  margin-left: 1rem;
  border-radius: 0.3rem;
  height: 2.8rem;
  /* min-height: 2.05rem; */
  display: flex;
  align-items: center;

  p {
    width: 100%;
    color: ${theme.colors.gray_2};
  }
`;
